import * as AgGrid from "ag-grid-community";
import * as dom from "../../utils/dom";
import * as gridUtils from "../../grid/utils";

export enum Action {
  EDIT = "edit",
  APPLY = "apply",
  REMOVE = "remove",
}

export function onActionCellClicked(params: AgGrid.CellClickedEvent, handler: (action: Action) => void) {
  const $target = params.event.target as HTMLElement;
  if (!$target) {
    return;
  }
  const $button = $target.tagName.toLowerCase() == "button" ? $target : $target.closest("button");

  if ($button) {
    handler($button.dataset["action"] as Action);
  }
}
